import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, share } from 'rxjs/operators';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  url = environment.baseUrl;

  constructor(public http: HttpClient, private store: StoreService) {
  }
  appendAccessToken(headers: HttpHeaders) {
    this.store.load();
    if (this.store.data && this.store.data.accessToken) {
      console.log('AccessToken ', this.store.data.accessToken);
      headers = headers.set('Authorization', `Bearer ${this.store.data.accessToken}`);
    }
    return headers;
  }
  addCommonHeaders(headers: HttpHeaders) {
    this.store.load();
    headers = headers.set('AppVersion', 'v0.0.1');
    console.log('this.store.data.login ', this.store.data.login);
    if (this.store.data && this.store.data.login) {
      headers = headers.set('__login__', this.store.data.login);
    }
    return headers;
  }
  get(endpoint: string, params?: any, reqOpts?: any, secure: boolean = true) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (const k of Object.keys(params)) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
      console.log('secure options:', reqOpts);
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    console.log('options:', reqOpts);
    return this.http.get(this.url + '/' + endpoint.replace(/^\/+/, ''), reqOpts).pipe(share(), catchError(this.handleError));
  }

  post(endpoint: string, body: any, reqOpts?: any, secure: boolean = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());

    //console.log("POST URL======"+this.url + '/' + endpoint.replace(/^\/+/, '') );
    //console.log(JSON.stringify(body));

    return this.http.post(this.url + '/' + endpoint.replace(/^\/+/, ''), body, reqOpts).pipe(share(), catchError(this.handleError));
  }

  put(endpoint: string, body: any, reqOpts?: any, secure = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    return this.http.put(this.url + '/' + endpoint.replace(/^\/+/, ''), body, reqOpts).pipe(catchError(this.handleError));
  }

  delete(endpoint: string, reqOpts?: any, secure: boolean = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    return this.http.delete(this.url + '/' + endpoint.replace(/^\/+/, ''), reqOpts).pipe(share(), catchError(this.handleError));
  }

  patch(endpoint: string, body: any, reqOpts?: any, secure: boolean = true) {
    reqOpts = reqOpts || {};
    if (secure) {
      reqOpts.headers = this.appendAccessToken(reqOpts.headers || new HttpHeaders());
    }
    reqOpts.headers = this.addCommonHeaders(reqOpts.headers || new HttpHeaders());
    return this.http.patch(this.url + '/' + endpoint.replace(/^\/+/, ''), body, reqOpts).pipe(share(), catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error', error);
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError((error.error && error.error.message) ||
      'Something bad happened; please try again later.');
  }
}
